import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginRequest } from "../api/auth";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";

const LoginPage = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const { login } = useAuth();
    const { t } = useTranslation();

    const handleSubmit = async (event: React.SubmitEvent) => {
        event.preventDefault(); // 🚨 prevents page reload

        try {
            const user = await loginRequest(username, password);
            login(user);
            navigate("/");
        } catch (err) {
            // Global Snackbar handles error
        }
    };

    return (
        <Box
            sx={{
                height: "100vh",
                backgroundImage: "url('/background.jpg')",
                backgroundSize: "cover",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Container maxWidth="xs">
                <Typography variant="h4" align="center" gutterBottom>
                    {t('app.title')}
                </Typography>

                {/* ✅ FORM WRAPPER */}
                <Box component="form" onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        margin="normal"
                        label={t('auth.username')}
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoFocus
                    />

                    <TextField
                        fullWidth
                        margin="normal"
                        label={t('auth.password')}
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    {/* ✅ type="submit" is critical */}
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{ mt: 2 }}
                        type="submit"
                    >
                        {t('auth.login')}
                    </Button>
                </Box>
            </Container>
        </Box>
    );
};

export default LoginPage;